import React from "react";

const ArrowCirclePath: React.FC<React.SVGProps<SVGSVGElement>> = ({
	width = 20,
	height = 20,
	...props
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Arrow circle path icon"
			{...props}
		>
			<path
				d="M2.5 9.375C2.84518 9.375 3.125 9.65482 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C12.3225 16.875 14.3767 15.7234 15.6221 13.958H13.333C12.988 13.9578 12.708 13.6781 12.708 13.333C12.7082 12.9881 12.9881 12.7082 13.333 12.708H17.083C17.4281 12.708 17.7078 12.988 17.708 13.333V17.083C17.708 17.4282 17.4282 17.708 17.083 17.708C16.738 17.7078 16.458 17.4281 16.458 17.083V14.9307C14.9741 16.8714 12.6337 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10C1.875 9.65482 2.15482 9.375 2.5 9.375ZM10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 10.3452 17.8452 10.625 17.5 10.625C17.1549 10.625 16.875 10.3452 16.875 10C16.875 6.20304 13.797 3.125 10 3.125C7.67756 3.12503 5.62325 4.27663 4.37793 6.04199H6.66699C7.01202 6.04217 7.29199 6.32192 7.29199 6.66699C7.29182 7.01191 7.01191 7.29182 6.66699 7.29199H2.91699C2.57192 7.29199 2.29217 7.01202 2.29199 6.66699V2.91699C2.29199 2.57181 2.57181 2.29199 2.91699 2.29199C3.26202 2.29217 3.54199 2.57192 3.54199 2.91699V5.06934C5.02597 3.12858 7.36629 1.87503 10 1.875Z"
				fill="#23262A"
			/>
		</svg>
	);
};

export default ArrowCirclePath;